import { whenIdle } from './idle';

/** Runs some time after the page has loaded, in a free moment: for what mustn't compete with it. */
export function afterLoadAndQuiet(run: () => void, delayMs: number): void {
  const go = () => {
    setTimeout(() => whenIdle(run), delayMs);
  };
  if (document.readyState === 'complete') go();
  else window.addEventListener('load', go, { once: true });
}
